import React from "react";
import UserIcon from "components/icons/UserIcon";
import HeartIcon from "components/icons/HeartIcon";
import "./UserDropdown.scss";
import BoxIcon from "components/icons/BoxIcon";

interface UserDropdownProps {
  isVisible: boolean;
  onClose: () => void;
  isAuthenticated?: boolean;
  onLogout?: () => void;
  onNavigateToProfile?: (section?: string) => void;
}

const UserDropdown: React.FC<UserDropdownProps> = ({
  isVisible,
  onClose,
  isAuthenticated = false,
  onLogout,
  onNavigateToProfile,
}) => {
  if (!isVisible) return null;

  // Add a class modifier based on authentication status
  const dropdownClass = isAuthenticated
    ? "user-dropdown-container authenticated"
    : "user-dropdown-container";

  return (
    <div className={dropdownClass}>
      <div className="user-arrow"></div>
      <div
        className={
          "user-dropdown-content" + (isAuthenticated ? " authenticated" : "")
        }
      >
        {isAuthenticated ? (
          <div className="user-dropdown-buttons">
            <div
              className="dropdown-item-authenticated"
              onClick={() => onNavigateToProfile && onNavigateToProfile("")}
            >
              <span>Mi perfil</span>
              <UserIcon size="1.5rem" color="#333" />
            </div>
            <div
              className="dropdown-item-authenticated"
              onClick={() =>
                onNavigateToProfile && onNavigateToProfile("orders")
              }
            >
              <span>Mis pedidos</span>
              <BoxIcon size="1.5rem" color="#333" />
            </div>
            <div
              className="dropdown-item-authenticated"
              onClick={() =>
                onNavigateToProfile && onNavigateToProfile("favorites")
              }
            >
              <span>Mis favoritos</span>
              <HeartIcon size="1.5rem" color="#333" filled={false} />
            </div>
            <div className="logout-button" onClick={onLogout}>
              <span>Cerrar sesión</span>
            </div>
          </div>
        ) : (
          <div className="user-dropdown-buttons">
            <button
              className="user-dropdown-button"
              onClick={() => {
                onClose();
                onNavigateToProfile && onNavigateToProfile("login");
              }}
            >
              Iniciar sesión
            </button>
            <button
              className="user-dropdown-button"
              onClick={() => {
                onClose();
                onNavigateToProfile && onNavigateToProfile("register");
              }}
            >
              Crear cuenta
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDropdown;
